import { render, staticRenderFns } from "./PopularArtworks.vue?vue&type=template&id=1b8a445e&scoped=true"
import script from "./PopularArtworks.vue?vue&type=script&lang=js"
export * from "./PopularArtworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a445e",
  null
  
)

export default component.exports